import React from 'react';
import { PropTypes } from 'prop-types';
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import { useSelector } from 'react-redux';
import InfoBarItem from './InfoBarItem';
import * as S from './styles';

const MainInfoBar = ({
  squadRole,
  dateOfBirth,
  placeOfBirth,
  weight,
  height,
  isLocal,
}) => {
  const { t } = useTranslation();
  const { data: match } = useSelector(state => state.matches.selectedMatch);
  return (
    <S.PlayerInfoBar isLocal={isLocal} competition={match?.competitionId}>
      <InfoBarItem
        isLocal={isLocal}
        label={t('position')}
        value={squadRole !== '' && squadRole ? squadRole : '-'}
      />
      <InfoBarItem
        isLocal={isLocal}
        label={t('birthDate')}
        value={
          dateOfBirth
            ? format(new Date(dateOfBirth), 'dd/MM/yyyy')
            : '-- / -- / ----'
        }
      />
      <InfoBarItem
        isLocal={isLocal}
        label={t('birthPlace')}
        value={placeOfBirth || '-'}
      />
      <InfoBarItem
        isLocal={isLocal}
        label={t('height')}
        value={height ? `${height} cm` : '-'}
      />
      <InfoBarItem
        isLocal={isLocal}
        label={t('weight')}
        value={weight ? `${weight} kg` : '-'}
      />
    </S.PlayerInfoBar>
  );
};

MainInfoBar.propTypes = {
  squadRole: PropTypes.string,
  dateOfBirth: PropTypes.string,
  placeOfBirth: PropTypes.string,
  weight: PropTypes.number,
  height: PropTypes.number,
  isLocal: PropTypes.bool,
};

MainInfoBar.defaultProps = {
  squadRole: '',
  dateOfBirth: '',
  placeOfBirth: '',
  weight: 0,
  height: 0,
  isLocal: false,
};

export default MainInfoBar;
